import { runCalculatorFloatingAsyncAction } from "../../../Core/Calculator2/Calculator2Compatibility";
import { IForm } from "../../IForm";
import { convertToAbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";

import { ICalculationFunctionValidator } from "./CalculationFunctionCallContext";

export class CalculationFunctionValidator implements ICalculationFunctionValidator {
    readonly #form: IForm;

    public constructor(form: IForm) {
        this.#form = form;
    }

    public validate(nodePath: string): void {
        runCalculatorFloatingAsyncAction(() => this.#form.revalidatePaths([nodePath].map(convertToAbsoluteModelPath)));
    }

    public validateAll(nodePaths: string[]): void {
        runCalculatorFloatingAsyncAction(() => this.#form.revalidatePaths(nodePaths.map(convertToAbsoluteModelPath)));
    }
}
